

import styles from "../static/styles/info.module.css";

import FRAMTIDSFULLMAKT  from "./download/andre dokument/Framtidsfullmakt.pdf";
import TESTAMENT         from "./download/andre dokument/Testament.pdf";
import INNKALLING        from "./download/andre dokument/Innkalling-aarsmote.pdf";
import Velferdsteknologi from "./download/andre dokument/Temakveld+Velferdstek.odp";
import OpeMote_16_10_25 from "./download/andre dokument/16.10.2025-Ope-møte.pdf";



//NB! CONVERT DOCX AND ODT FILES TO PDF ONLINE 
//NEW DOWNLOAD FILE USE: import file as seen above and use like so in <a> tag: href={samplePDF1} target="_blank" rel="noreferrer"

//const Downloader = ({ files }) => {
//    return (
//        <div style={{ display: 'none' }}>
//            {
//                files?.map(({ url }) => <iframe src={url} />)
//            }
//        </div>
//    );
//}

export default function Info() {
    
    return <>
        <div className="content-page">
            <div className="content-wrap">
                <div className="content">
                    <div className={`${styles.this_header}`}><div className="header1">Informasjon og andre dokument</div></div>
                    <div className={`${styles.epost} div-center content-item`}>post@bustadklubben.no</div>
                    <div className={`${styles.kategorier}`}>
                        
                        
                        <div className={`${styles.kategori} text2 ${styles.content_item}`}>
                            <h1>Andre Dokument</h1>
                            <div className={`${styles.btn_list}`}>
                                <button><a href={FRAMTIDSFULLMAKT} target="_blank" rel="noreferrer">FRAMTIDSFULLMAKT</a></button>
                                <button><a href="/byggetida-1992">Byggetida i 1992</a></button>
                                <button><a href={TESTAMENT} target="_blank" rel="noreferrer">TESTAMENT</a></button>    
                                <button><a href={INNKALLING} target="_blank" rel="noreferrer">INKALLING TIL ÅRSMØTE</a></button>
                                <button><a href={OpeMote_16_10_25} target="_blank" rel="noreferrer">Ope møte den 16.10.2025</a></button>
                            </div>
                        </div>
                        <div className={`${styles.kategori} text2 ${styles.content_item}`}>
                            <h1>Velferdsteknologi</h1>
                            <div className={`${styles.btn_list}`}>
                                <button><a href={Velferdsteknologi} target="_blank" rel="noreferrer">KVAM HERAD: VELFERDSTEKNOLOGI</a></button>   
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
    </>
}